module.exports = __WEBPACK_EXTERNAL_MODULE_116__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"hammerjs","commonjs2":"hammerjs","amd":"hammerjs","root":"Hammer"}
// module id = 116
// module chunks = 0